import React, { useState } from "react";
import { Button, useMediaQuery } from "@mui/material";
import { s3baseUri } from "../../../config/config";
import { noImagePlaceholder } from "../../../assets";
import CustomConfirmation from "../../../components/popUp/CustomConfirmation";
import { useIds } from "../../../hook/AdminContext";

export default function InvitationCard({
  invitation,
  onAccept,
  onReject,
  submittingResp,
}) {
  const { userInfo } = useIds();
  const { client_object, user_type, access } = invitation;
  let isTablet = useMediaQuery("(min-width:767px)");

  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [showAdditionalInfo, setShowAdditionalInfo] = useState(false);

  // 🧩 Extract only true access permissions (nested)
  const trueAccess = [];
  Object.entries(access).forEach(([section, permissions]) => {
    Object.entries(permissions).forEach(([key, value]) => {
      if (value) {
        trueAccess.push(`${section} → ${key}`);
      }
    });
  });

  const handleConfirmationReject = () => {
    if (!userInfo?.has_any_access) {
      setShowAdditionalInfo(true);
    } else {
      setShowAdditionalInfo(false);
    }
    setOpenConfirmation(true);
  };

  const renderAccess = () => {
    const accessEntries = Object.entries(access);
    const hasAccess = accessEntries.some(([_, perms]) =>
      Object.values(perms).some(Boolean)
    );

    if (!hasAccess) {
      return <p className="no-access">No access granted</p>;
    }

    return (
      <>
        <div className="access-group-wrapper">
          {accessEntries.map(([section, perms]) => {
            const truePerms = Object.entries(perms)
              .filter(([_, value]) => value)
              .map(([key]) => key);

            if (truePerms.length === 0) return null;

            return (
              <div
                key={section}
                className="access-group d-flex align-items-start"
              >
                <p className="mb-0 text-capitalize">
                  {section.replaceAll("_", " ")} :
                </p>
                <div className="">
                  {truePerms.map((perm) => (
                    <span
                      key={perm}
                      className="text-capitalize outlined-chip basic d-inline-block ms-2 mb-2"
                    >
                      {perm.replaceAll("_", " ")}{" "}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </>
    );
  };

  return (
    <>
      {openConfirmation && (
        <CustomConfirmation
          open={openConfirmation}
          setOpen={setOpenConfirmation}
          title={"Are you sure you want to reject this invitation?"}
          headerHeading={"Reject Invitation"}
          handleAgree={() =>
            onReject(invitation, () => {
              setOpenConfirmation(false);
            })
          }
          additionalInfo={
            showAdditionalInfo
              ? "By rejecting this invitation, you’ll lose access, and your account will be deleted."
              : null
          }
          infoTitle={showAdditionalInfo ? "Warning" : null}
        />
      )}
      <div className="tw-card tw-p-6">
        <div className="invitation-header">
          <div
            className={`tw-flex-shrink-0 tw-bg-slate-100 tw-rounded-lg ${
              isTablet ? "tw-w-52 tw-h-52" : "tw-w-20 tw-h-20"
            }`}
          >
            {client_object?.profile_image?.thumbnail_2 ||
            client_object?.profile_image?.thumbnail_1 ? (
              <img
                className="img-fluid rounded w-100 h-100 tw-cursor-pointer"
                src={
                  client_object?.profile_image?.thumbnail_2
                    ? s3baseUri + client_object?.profile_image?.thumbnail_2
                    : s3baseUri + client_object?.profile_image?.thumbnail_1
                }
                onError={(e) => {
                  e.target.src = noImagePlaceholder;
                }}
                alt={client_object.company_name + " Logo"}
                style={{ objectFit: "cover" }}
              />
            ) : (
              `${client_object.company_name.charAt(0)}`
            )}
          </div>

          <div className="w-100">
            <div className="d-flex  align-items-start justify-content-between">
              <h6 className={`text-capitalize ${isTablet ? "text-xl" : ""}`}>
                {client_object.company_name}
              </h6>
              <span className="outlined-chip d-inline-block text-capitalize">
                {user_type} User
              </span>
            </div>
            <div className={`${isTablet ? "d-block" : "d-none"}`}>
              <h6>Access Granted:</h6>
              {renderAccess()}
            </div>
          </div>
        </div>
        <div className={`${isTablet ? "d-none" : "d-block mt-2 mb-5"}`}>
          <h6>Access Granted:</h6>
          {renderAccess()}
        </div>
        <div className="invitation-actions">
          <button
            onClick={() => handleConfirmationReject()}
            className="btn-outlined-sm"
            disabled={submittingResp}
          >
            Reject
          </button>
          <button
            className="btn-contained-sm"
            onClick={() => onAccept(invitation)}
            disabled={submittingResp}
          >
            Accept
          </button>
        </div>
      </div>
    </>
  );
}
